<template>
  <table class="tableSize flipTable">
    <tr>
      <th class="tableHeader" v-for="(head, n) in header" :key="n">
        {{head}}
      </th>
    </tr>
    <tbody>
      <tr v-for="(data, index) in viewData" :key="index">
        <td class="sortCenter">
          {{data.creative_kr_nm ? data.creative_kr_nm : data.group_nm}}
        </td>
        <td class="sortCenter">
          {{data.ad_knd_nm}}
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{parseDataType(data.imp_cnt)}}
          </div>
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{parseDataType(data.click_cnt)}}
          </div>
        </td>
        <td class="sortRight">
          <div class="data_wrap">
            {{isNaN(data.ctr) ? 0 : data.ctr.toFixed(1)}}
          </div>
        </td>
        <td class="sortRight" style="padding-right: 0;">
          <div class="data_wrap">
            {{parseDataType(data.sum_budget_amt)}}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { parseDataType } from '@/assets/func'

  export default {
    name: 'creativeGroup_table',
    props: {
      viewData: Array,
      isExcel: Boolean
    },
    data () {
      return {
        header: [
          '소재 그룹',
          '상품명',
          '노출수',
          '클릭수',
          'CTR(%)',
          '소진 광고비'
        ]
      }
    },
    methods: {
      parseDataType (data) {
        return parseDataType(data)
      }
    },
    mounted () {
      window.scroll(0, 0)
      document.body.scrollTop = 0
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// CgTable.vue?d542373a